import ModelColorItemInterface from "../../interfaces/model/ModelColorItemInterface";
import {Link} from "react-router-dom";
import {getBaseImagePath} from "../catalog/Utils";
import React, {useContext} from "react";
import Money from "../core/Money";
import {BasketItemInterface} from "../../interfaces/core/BasketItemInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import useDatalayer, {EcommerceAction} from "../../utils/useDataLayer";
import {TriggerEventName} from "../../interfaces/core/TriggerEventInterface";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

export default function AdditionalGood({modelColorItem}: { modelColorItem: ModelColorItemInterface }) {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const {action: dataLayerManagerAction, transaction: dataLayerManagerTransaction} = useDatalayer()


    const currentImage = (modelColorItem: ModelColorItemInterface) => {
        let currentImage = modelColorItem.images.find(image => image.type === 'front')
        if (currentImage?.url) {
            currentImage.url = currentImage?.url.replace(/big/, 'thumbnail')
        }
        return currentImage
    }

    const defaultBasketData = modelColorItem.default_basket_data

    const handleAddToBasket = () => {
        const basketItem: BasketItemInterface = {
            modelColorItem: modelColorItem,
            //@ts-ignore
            itemId: defaultBasketData.item_id,
            color: defaultBasketData?.color as string,
            size: defaultBasketData?.size as string,
            quantity: 1,
            createdAt: new Date(),
            isSelected: true
        };

        //  console.log("basketItem", basketItem);

        dispatch({type: ReducerActionType.ADD_TO_BASKET, payload: basketItem});
        dataLayerManagerAction(EcommerceAction.ADD_TO_CART, [modelColorItem]);
        dispatch({
            type: ReducerActionType.ADD_TRIGGER_EVENT,
            payload: {
                event_name: TriggerEventName.CART_ADD,
                event_value: {
                    model_id: modelColorItem.model_id,
                    color: defaultBasketData?.color as string,
                    price: modelColorItem.min_price.amount
                },
                customer_identity_type: state.customer?.id ? 'customer_id' : null,
                customer_identity_value: state.customer?.id?.toString() || null,
            },
        });

    };

    return (<div className={'col-12 col-md-5 mr-3'} >
        <div className="row">
            <div className="col-3 d-flex align-items-center">
                <Link
                    to={`/catalog/${modelColorItem.model_id}/${modelColorItem.special_transliterated_name.toLowerCase()}/${modelColorItem.color_special.toLowerCase()}/`}>
                    <img src={getBaseImagePath() + currentImage(modelColorItem)?.url} className={''} alt=""/>
                </Link>
            </div>
            <div className="col-9">
                <div className={'my-3'}>
                    <Link
                        to={`/catalog/${modelColorItem.model_id}/${modelColorItem.special_transliterated_name.toLowerCase()}/${modelColorItem.color_special.toLowerCase()}/`}>
                        {modelColorItem.name}
                    </Link>
                </div>
                <div className={'my-3'}>
                    <b><Money value={modelColorItem.min_price}/></b>
                </div>
                {defaultBasketData && <div className={'my-3'}>
                    <button className={'btn btn-secondary btn-small'} onClick={() => {
                        handleAddToBasket()
                    }}>В корзину</button>
                </div>}
            </div>
        </div> 
    </div>)
}